import {PositionType, FlexDirection, Justify, Align} from '@wonderlandengine/react-ui';
import {
    Column,
    Container,
    Image,
    Panel,
    PanelProps,
    Row,
    Text,
} from '@wonderlandengine/react-ui/components';
import {MenuPanels} from '../../models/UIModel.js';
import {MalUI} from '../components/mal-ui.js';
import {MenuBackground} from '../components/menu-backgrounds.js';
import {MenuButton} from '../components/menu-button.js';
import {colorSwatch} from '../utils/colorSwatch.js';
import {goToMenu} from '../utils/goToMenu.js';
import {Window} from '../components/window.js';
import {useRotBMaterialContext} from '../utils/rotb-material-context.js';
import {ColoredImage} from '../components/colored-image.js';
import {UiTexturesManager} from '../components/ui-textures-manager.js';
import {Localization} from '../../utils/Localization.js';
import {useDailyTimer} from '../hooks/useDailyTimer.js';

export const MainMenu = (props: React.PropsWithChildren<PanelProps> & {}) => {
    const mats = useRotBMaterialContext();
    const [showDailyRewardTimer, dailyRewardTimerText, textRef] = useDailyTimer();

    return (
        <Container
            position={PositionType.Absolute}
            width="100%"
            height="100%"
            flexDirection={FlexDirection.Row}
            justifyContent={Justify.Center}
        >
            {showDailyRewardTimer && (
                <Panel
                    z={0.01}
                    rounding={5}
                    position={PositionType.Absolute}
                    width={500}
                    height={30}
                    top={20}
                    alignItems={Align.Center}
                    alignContent={Align.Center}
                    backgroundColor="#021A48"
                    justifyContent={Justify.Center}
                >
                    <Text
                        ref={textRef}
                        textAlign="center"
                        z={0.01}
                        fontSize={18}
                        material={mats.regularTextMaterial}
                        text={dailyRewardTimerText}
                    ></Text>
                </Panel>
            )}
            <Column marginTop={36}>
                <Window>
                    <MenuBackground top={31} left={31}>
                        <Image
                            rounding={0}
                            src={UiTexturesManager.instance.logoWide}
                            width={520}
                            height={130}
                            top={-12}
                            left={-12}
                        />
                        <Container position={PositionType.Absolute}>
                            <MalUI
                                top={120}
                                left={55}
                                alignSelf={Align.Center}
                                width={300}
                                height={300}
                            ></MalUI>
                            <ColoredImage
                                color={'#00000090'}
                                src={mats.circleTexture}
                                width={190}
                                height={20}
                                top={80}
                                left={165}
                            />
                        </Container>
                        {/* <Container left={175} top={125} position={PositionType.Absolute}>
                            <MalSpeech>
                                You can tap me to cycle through my wardrobe!
                            </MalSpeech>
                        </Container> */}

                        <Container top={370} alignSelf={Align.Center} width={250}>
                            <MenuButton
                                height={54}
                                color={colorSwatch.MainMenuShoppe}
                                fontSize={18}
                                icon={UiTexturesManager.instance.iconLeaderboard}
                                iconWidth={40}
                                iconHeight={40}
                                margin={6}
                                onClick={(e) => goToMenu(MenuPanels.Leaderboard)}
                            >
                                {Localization.instance.get('Leaderboard')}
                            </MenuButton>
                            <MenuButton
                                height={54}
                                margin={6}
                                color={colorSwatch.MainMenuMissions}
                                fontSize={24}
                                icon={UiTexturesManager.instance.checklist}
                                iconWidth={38}
                                iconHeight={40}
                                onClick={(e) => goToMenu(MenuPanels.MissionRequirements)}
                            >
                                {Localization.instance.get('Missions')}
                            </MenuButton>
                            <MenuButton
                                height={54}
                                margin={6}
                                color={colorSwatch.MainMenuMore}
                                fontSize={24}
                                icon={UiTexturesManager.instance.iconMalware}
                                iconWidth={40}
                                iconHeight={40}
                                onClick={(e) => goToMenu(MenuPanels.Shoppe)}
                            >
                                {Localization.instance.get('UpgradeShop')}
                            </MenuButton>
                        </Container>
                    </MenuBackground>
                </Window>
                <Row justifyContent={Justify.SpaceAround}>
                    <MenuButton
                        width={250}
                        height={54}
                        margin={6}
                        color={colorSwatch.Options}
                        fontSize={28}
                        icon={UiTexturesManager.instance.iconOptions}
                        iconWidth={38}
                        iconHeight={40}
                        onClick={() => goToMenu(MenuPanels.Options)}
                    >
                        {Localization.instance.get('Options')}
                    </MenuButton>
                    <MenuButton
                        width={250}
                        height={54}
                        margin={6}
                        color={colorSwatch.AcceptButton}
                        fontSize={32}
                        iconWidth={38}
                        iconHeight={40}
                        onClick={() => {
                            goToMenu(MenuPanels.ModeSelect);
                        }}
                        animate={true}
                        icon={UiTexturesManager.instance.arrow}
                    >
                        {Localization.instance.get('Play')}
                    </MenuButton>
                </Row>
            </Column>
        </Container>
    );
};
